import { instanceToPlain } from "class-transformer";
import CommentRequestResource from "common/resources/Project/Config/Forum/Comment/CommentRequestResource";
import CommentResponseResource from "common/resources/Project/Config/Forum/Comment/CommentResponseResource";
import BaseCommentIdApi from "./BaseCommentIdApi";

export default class CommentIdApi extends BaseCommentIdApi {
	/**
	 * @description Get a comment by id
	 */
	public async getById(projectId: string, postId: string, commentId: string): Promise<CommentResponseResource> {
		return this.getRequest<CommentResponseResource>(this.getBaseUrl({ projectId, postId, commentId })).then((response) => CommentResponseResource.hydrate(response));
	}

	/**
	 * @description Count replies for a comments
	 */
	public async countReplies(projectId: string, postId: string, commentId: string): Promise<{ count: number }> {
		return this.getRequest<{ count: number }>(this.getBaseUrl({ projectId, postId, commentId }));
	}

	/**
	 * @description Reply to a comment
	 */
	public async reply(projectId: string, postId: string, commentId: string, request: CommentRequestResource): Promise<CommentResponseResource> {
		return this.postRequest<CommentResponseResource>(this.getBaseUrl({ projectId, postId, commentId }), instanceToPlain(request)).then((response) =>
			CommentResponseResource.hydrate(response),
		);
	}

	/**
	 * @description Check if a comment can be deleted by the user
	 */
	public async canDelete(projectId: string, postId: string, commentId: string): Promise<boolean> {
		return this.getRequest(`${this.getBaseUrl({ projectId, postId, commentId })}/can-delete`)
			.then(() => true)
			.catch(() => false);
	}

	/**
	 * @description Delete a comment
	 */
	public async delete(projectId: string, postId: string, commentId: string): Promise<void> {
		return this.deleteRequest(this.getBaseUrl({ projectId, postId, commentId }));
	}
}
